/**
 * @module views\psm\workorder
 */
import Vue from "vue";
import Component from "vue-class-component";
import Batch from "../batch/batch";
import BatchView from "../batch/components/batchView/batchView";
import { Watch } from "vue-property-decorator";

@Component({
  components: {
    batch: Batch,
    BatchView
  }
})
export default class Workorder extends Vue {
  private headers: ITableHeader[] = [];
  private args = {
    date: "",
    structure_id: ""
  };

  private dicHeaders: IndexObject = {};

  @Watch("headers")
  private observeHeaders() {
    if (this.headers) {
      this.dicHeaders = {};
      for (const h of this.headers) {
        this.dicHeaders[h.value] = h;
      }
      this.hide(["O-sort", "Batch"]);
    }
  }

  private hide(hs: string[]) {
    for (const h of hs) {
      let col = this.dicHeaders[h] as ITableHeader;
      col.hide = true;
    }
  }
}
